import { Icon } from '@/components/brand/Icon';
import { LinkButton } from '@/components/ui/Button';
import { useAcademy } from '@/lib/academy';
import { useI18n } from '@/lib/i18n';

export function ClosingCTA(): React.JSX.Element {
  const { t } = useI18n();
  const academy = useAcademy();

  return (
    <section className="bg-midnight py-24 text-on-midnight md:py-32">
      <div className="mv-container flex flex-col items-center gap-6 text-center">
        <p className="text-overline font-semibold uppercase text-on-midnight-accent">
          {t('cta.overline')}
        </p>

        <h2 className="max-w-[900px] font-display text-[clamp(2.25rem,5.5vw,4.5rem)] font-light leading-[1.06] tracking-[-0.02em]">
          {t('cta.title')}
        </h2>

        <p className="max-w-[600px] text-body-lg text-on-midnight-muted">{t('cta.sub')}</p>

        <div className="flex flex-wrap justify-center gap-3 pt-3">
          <LinkButton to="/booking/subject" size="lg" trailingIcon="arrow-right">
            {t('nav.bookTrial')}
          </LinkButton>
          <a
            href={academy.whatsappUrl}
            target="_blank"
            rel="noreferrer noopener"
            className="inline-flex h-13 items-center gap-2 rounded-md border border-border-strong bg-surface px-8 text-body font-medium text-primary hover:bg-subtle"
          >
            <Icon name="whatsapp" size={20} />
            {t('booking.failed.whatsapp')}
          </a>
        </div>
      </div>
    </section>
  );
}
